import Image from '../../../components/AppImage';
import { formatDistanceToNow } from 'date-fns';

const ConversationItem = ({ conversation, isActive, onClick, isOnline }) => {
  const formatTimestamp = (date) => {
    if (!date) return '';
    
    try {
      const msgDate = new Date(date);
      return formatDistanceToNow(msgDate, { addSuffix: true });
    } catch (error) {
      return '';
    }
  };

  const otherParticipant = conversation?.participants?.[0];
  const lastMessage = conversation?.lastMessage;

  return (
    <div
      onClick={onClick}
      className={`
        flex items-center gap-3 p-3 cursor-pointer transition-smooth border-b border-border
        ${isActive ? 'bg-blue-50' : 'hover:bg-muted'}
      `}
    >
      <div className="relative flex-shrink-0">
        <Image
          src={otherParticipant?.avatarUrl || 'https://via.placeholder.com/40'}
          alt={`${otherParticipant?.fullName || 'User'} profile picture`}
          className="w-10 h-10 rounded-full object-cover"
        />
        {isOnline && (
          <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full" />
        )}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <h3 className="font-semibold text-sm text-foreground line-clamp-1">
            {otherParticipant?.fullName || 'Unknown User'}
          </h3>
          <span className="text-xs text-muted-foreground flex-shrink-0">
            {formatTimestamp(conversation?.lastMessageAt || conversation?.createdAt)}
          </span>
        </div>
        
        <p className="text-xs text-muted-foreground mb-1 line-clamp-1">
          {otherParticipant?.email || ''}
        </p>
        
        <div className="flex items-center justify-between gap-2">
          <p className={`text-sm line-clamp-1 ${
            conversation?.unreadCount > 0 ? 'font-medium text-foreground' : 'text-muted-foreground'
          }`}>
            {lastMessage?.content || 'No messages yet'}
          </p>
          {conversation?.unreadCount > 0 && (
            <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#FF6A00] text-white text-xs font-bold flex items-center justify-center">
              {conversation?.unreadCount}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConversationItem;